/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_PLATFORMJK} from '../../constans/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";
import {
    HEAR_DETAIL_REQUEST,
    HEAR_DETAIL_SUCCESS,
    HEAR_DETAIL_FAILURE
} from "../../types/index";

/**
 * HearGetDetailAction
 */
const HearGetDetailV2Action = (hearId, fanpageId, actor = null) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_PLATFORMJK}/api/v2/hears/${hearId}`
        },
        method: "GET",
        headers: (headers()),
        types: [
            HEAR_DETAIL_REQUEST,
            {
                type: HEAR_DETAIL_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "actor": actor,
                        "action_type": HEAR_DETAIL_SUCCESS,
                        "fanpage_id": fanpageId,
                        "data": data,
                    }
                }
            },
            {
                type: HEAR_DETAIL_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "action_type": HEAR_DETAIL_FAILURE,
                        "actor": actor,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {HearGetDetailV2Action}

